import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/config")({
  component: () => <div className="text-[var(--iris-fg-3)]">Config — placeholder</div>,
});
